export default function(_parent,_settings){

  _parent.networking={};
  if(!('online_check_url' in _settings) || _settings.online_check_url===false)
  {
    if('app_path' in _settings)
    {
      _settings.online_check_url=(_settings.app_path.endsWith('/') ? _settings.app_path.slice(0, -1) : _settings.app_path)+'/manifest.part.json';
    }
    else
    {
      _settings.online_check_url=false;
    }
  }

  if(!('online_check_timeout' in _settings))
  {
    _settings.online_check_timeout='5000';
  }

  _parent.networking._log = function(type,source,message,data='')
  {
    _parent._log(type,source,message,data,'networking');
  };

  _parent.networking._settings={};
  _parent.networking._settings.online_check_timeout=_settings.online_check_timeout;
  _parent.networking._settings.online_check_url=_settings.online_check_url;

  _parent.networking.timeout = function(callback){
    if(typeof callback === 'function')
    {
      return setTimeout(function() {
            callback();
            reject(new Error('Request timed out @'+_parent.networking._settings.online_check_timeout));
          }, _parent.networking._settings.online_check_timeout);
    }
    else
    {
      return false;
    }
  };

  _parent.networking.ifOnlineAsync = async function(callback,fail_callback)
  {
    if(await this.isOfflineAsync(false))
    {
      if(typeof callback === 'function')
      {
        return await callback();
      }
      else
      {
        this._log('error','ifOnlineAsync','callback is not a function!');
      }
    }
    else
    {
      if(typeof fail_callback === 'function')
      {
        return await fail_callback();
      }
      else
      {
        this._log('error','ifOnlineAsync','fail_callback is not a function!');
      }
    }
  };

  _parent.networking.isOfflineAsync = async function(suggested_offline_status=false,force=false)
  {
    return _parent.networking.isOffline(suggested_offline_status,force);
  };

  _parent.networking.isOffline = async function(suggested_offline_status=false,force=false)
  {
    let _this=this;
    let didTimeOut = false;
    let run_fetch = true;
    if(!_parent.networking._settings.online_check_url)
    {
      _this._log('error','isOfflineAsync','Missing online check url!');
      run_fetch=false;
    }
    else
    {
      //_this._log('debug','Fetch using online_check_url...',_parent.networking._settings.online_check_url);
    }

    if(suggested_offline_status)
    {
      force=true;
    }

    if(!force)
    {
      let last_one_min = ((Math.floor(+new Date() / 1000))-(60));
      if(_this.last_checked_online && (_this.last_checked_online > last_one_min))
      {
        //_this._log('debug','isOfflineAsync','Skipping check '+_this.last_checked_online+' > '+last_one_min);
        run_fetch=false;
      }
      else
      {
        //_this._log('debug','isOfflineAsync','Will check '+_this.last_checked_online+' > '+last_one_min);
      }
    }
    else
    {
      _this._log('debug','isOfflineAsync','Check forced!');
      let last_five_sec = ((Math.floor(+new Date() / 1000))-(5));// 5 second check min
      if(_this.last_checked_online && (_this.last_checked_online > last_five_sec))
      {
        run_fetch=false;
      }
    }

    return new Promise(function(resolve, reject) {
      if(!run_fetch)
      {
        //_this._log('warning','isOfflineAsync','fetch off',run_fetch);
        resolve(_this.offline);
      }
      else
      {
        _this._log('log','isOfflineAsync','Looking for net....');
        const timeout = _parent.networking.timeout(function() {
          didTimeOut = true;
          reject(new Error('Request timed out @'+_parent.networking._settings.online_check_timeout));
        });

        fetch(_parent.networking._settings.online_check_url+'#sw:no-cache')
          .then(function(response) {
            // Clear the timeout as cleanup
            clearTimeout(timeout);
            if(!didTimeOut) {
              _this._log('log','isOfflineAsync','fetch worked', response);
              if(('status' in response) && response.status != 503)
              {
                _this.last_checked_online = Math.floor(+new Date() / 1000);
                resolve(false);
              }
              else
              {
                resolve(true);
              }
            }
          })
          .catch(function(err) {
            _this._log('error','isOfflineAsync','fetch failed! ', err);

            // Rejection already happened with setTimeout
            if(didTimeOut) return;
            // Reject with error
            reject(err);
          });
      }
    })
      .then(function(response) {
        if(typeof response == "boolean")
        {
          _this.offline=response;
        }
        else
        {
          _this.offline=suggested_offline_status;
        }
        if(_this._offline!=_this.offline)
        {
          if(_this.offline)
          {
            _this._log('info','isOfflineAsync','Offline (inherited)',[_this.offline,response]);
          }
          else
          {
            _this._log('info','isOfflineAsync','Online',_this.offline,response);
          }
          window.dispatchEvent(new CustomEvent('fw-workspace-offline_status', {detail:_this.offline}));
        }
        _this._offline=_this.offline;
        return _this.offline;
      })
      .catch(function(err) {
        _this.offline=true;
        _this._log('error','isOfflineAsync','Offline', err);
        if(_this._offline!=_this.offline)
        {
          window.dispatchEvent(new CustomEvent('fw-workspace-offline_status', {detail:_this.offline}));
        }
        _this._offline=_this.offline;
        return _this.offline;
      });
  };
  _parent.networking._log('debug','init','Available');

}
